import React from 'react'
import { Button, IconUserAddPlus, IconCheckCircle, IconCloseOutlined } from '@tutorbot/ui-components'
import { addNewClientModal, Alert } from '../UI/Modal/ModalContent'
import { Form, Modal } from 'antd'
import { addNewClients } from '../../services/api/ums/client'
import isArray from 'lodash/isArray'
import moment from 'moment'
import { useDispatch } from 'react-redux'
import { setClientsListLastUpdatedAt } from '../../store/actions'
import { v4 } from 'uuid'
import styles from './AddNewClientButton.module.css'

const AddNewClientButton = () => {
  const [form] = Form.useForm()
  const dispatch = useDispatch()

  const onSubmit = ({ autoGenerate, ...values }) => {
    if (autoGenerate === 'false') {
      values.token = `${v4()}${v4()}${v4()}`.substring(0, 40)
    }
    addNewClients(values)
      .then(() => {
        const icon = <IconCheckCircle size={'sm'} fill={'var(--success-color)'} />
        const title = 'Success'
        const content = (
          <div className={styles.success_text}>
            <p>Client has been successfully added.</p>
            <span >
              Token: <span className={styles.token_text}>{values.token}</span>
            </span>
          </div>
        )

        Alert(title, content, icon, handleSuccess)
      })
      .catch((error) => {
        const errorMessage = !isArray(error.response.data.message)
          ? error.response.data.message
          : error.response.data.message[0].messages[0].message

        const icon = <IconCloseOutlined size={'sm'} fill={'var(--error-color)'} />
        const title = 'Error'
        const content = <p className={styles.error_text}>{errorMessage}</p>

        Alert(title, content, icon, handleError)
      })
      .finally(
        () => dispatch(
          setClientsListLastUpdatedAt(moment().valueOf())
        )
      )
  }

  const handleSuccess = () => {
    Modal.destroyAll()
    form.resetFields()
  }

  const handleError = () => {
    // form.resetFields()
  }

  return (
    <Button
        size='middle'
        className={styles.button}
        onClick={() => addNewClientModal(
          onSubmit,
          form
        )}
    >
      Add new client
      <IconUserAddPlus size={'sm'} />
    </Button>
  )
}

export default AddNewClientButton
